import {singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {appState} from "../../app.state";
import {TasklistToggleViewCommand} from "../tasklist-toggle-view.command";
import {ICommandHandler} from "./i-command.handler";

/**
 * Handler for TasklistToggleViewCommand
 * Toggles the tasklist view between 'column-view' and 'list-view'
 */
@CommandHandler(TasklistToggleViewCommand)
@singleton()
export class TasklistToggleViewCommandHandler implements ICommandHandler<void> {

    /**
     * Handles the command by toggling the view state in app state
     * @param command The toggle view command
     */
    public async handle(command: TasklistToggleViewCommand): Promise<void> {
        // Toggle view state - View updates happen through subscription
        appState.tasklistView = (appState.tasklistView === 'column-view') 
            ? 'list-view' 
            : 'column-view';
    }
}